import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { CurrencyMultiSelect } from '@/components/currency-multi-select';

interface PresentmentCurrenciesSelectProps {
  currencies: string[];
}

export const PresentmentCurrenciesSelect = ({ currencies }: PresentmentCurrenciesSelectProps) => {
  const { t } = useTranslation(['stores', 'common']);
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<{ presentmentCurrencies: string[] }>();

  const handleSelectAll = () => {
    setValue('presentmentCurrencies', currencies);
  };

  return (
    <div id="store-display-currency-select" className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex-1 space-y-1">
          <div className="flex items-center gap-1">
            <Label>{t('form.displayCurrencies')}</Label>
            <span className="text-red-500">*</span>
          </div>
          <p className="text-xs text-gray-500">
            {t('form.displayCurrenciesDescription')}
          </p>
        </div>
        <Button type="button" variant="ghost" size="sm" onClick={handleSelectAll} className="self-start">
          {t('form.selectAll')}
        </Button>
      </div>
      <Controller
        name="presentmentCurrencies"
        control={control}
        render={({ field: { onChange, value } }) => (
          <CurrencyMultiSelect
            currencies={currencies}
            selected={value ?? []}
            onChange={onChange}
            placeholder={t('form.searchCurrency')}
          />
        )}
      />
      {errors.presentmentCurrencies && (
        <p className="text-sm text-red-500">{errors.presentmentCurrencies.message as string}</p>
      )}
    </div>
  );
};
